export const CURRENT_CTC_RANGE = {
  1: { min: 0, max: 500000 },
  2: { min: 500001, max: 1000000 },
  3: { min: 1000001, max: 1500000 },
  4: { min: 1500001, max: 2000000 },
  5: { min: 2000001, max: Infinity },
};

export const EXPECTED_CTC_RANGE = {
  1: { min: 0, max: 500000 },
  2: { min: 500001, max: 1000000 },
  3: { min: 1000001, max: 1500000 },
  4: { min: 1500001, max: 2000000 },
  5: { min: 2000001, max: Infinity },
};

export const customLocale = {
  lang: {
    locale: "en",
    shortWeekDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  },
  timePickerLocale: {},
};

export const pageTitles = [
  {
    path: "/requisitions/:r_id/candidate/:c_id/linked-candidate/:lc_id",
    title: "Interview Round | Talenthub",
  },
  { path: "/requisitions/:r_id", title: "Requisition Details | Talenthub" },
  { path: "/requisitions", title: "Requisitions | Talenthub" },
  { path: "/candidates/:c_id", title: "Candidate Details | Talenthub" },
  { path: "/candidates", title: "Candidates | Talenthub" },
  {
    path: "/candidate-form/:c_id",
    title: "Recruitment Form | Talenthub",
  },
  {
    path: "/candidatefeedback/:c_id/requisition/:r_id",
    title: "Candidate Feedback | Talenthub",
  },
  {
    path: "/applicants",
    title: "Applicants | Talenthub",
  },
  {
    path: "/applicants/:a_id",
    title: "Applicant Details | Talenthub",
  },
  {
    path: "/dashbaord",
    title: "Dashboard | Talenthub",
  },
  {
    path: "/candidates/:c_id/view-candidate-details",
    title: "Recruitment Form Details | Talenthub",
  },
  { path: "/interviews", title: "Interviews | Talenthub" },
  { path: "/settings/:path", title: "Settings | Talenthub" },
  { path: "/login", title: "Login | Talenthub" },
  { path: "/", title: "Home | Talenthub" },
];

//quill editor configurations

export const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ color: [] }, { background: [] }],
    ["link"],
    ["clean"],
  ],
};

export const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "color",
  "background",
  "link",
];
//hardcoded for now

export const fileTypes = {
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
};

export const ALLOWED_INTERNAl_EMAILS = [
  "kapil.c@intelegain.com",
  "hr@intelegain.com",
  "sanjeev.t@intelegain.com",
  "ronnie.s@intelegain.com",
  "aslam.s@intelegain.com",
];
